import React, { useState } from 'react'
import { Button, Card, Flex, Stack, Title, Text, ThemeIcon, TextInput } from '@mantine/core'
import { Icon } from '@iconify/react'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useActions } from 'src/state'

const validationSchema = yup.object({
    email: yup.string().required('Email is required').email('Invalid email address'),
})

const RequestPasswordResetForm: React.FC = () => {

    const [status, setStatus] = useState<'success' | 'failed' | 'idle'>('idle')
    const requestPasswordResetAction = useActions().requestPasswordResetAction

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema,
        validateOnBlur: true,
        validateOnChange: true,
        onSubmit: async (values) => {
            const success = await requestPasswordResetAction({ email: values.email })
            if (success) {
                setStatus('success')
            }
        },
    })

    if (status === 'success') {
        return (
            <Flex
                justify="center"
                align="center"
            >
                <Card
                    withBorder
                    shadow="sm"
                    p="xl"
                    w={400}
                >
                    <Stack align="center" gap="md">
                        <ThemeIcon size={60} radius="xl" color="green" variant="light">
                            <Icon icon="mdi:email-check" width={32} />
                        </ThemeIcon>
                        <Title order={3} ta="center">Check Your Email</Title>
                        <Text c="dimmed" ta="center" size="sm">
                            We've sent a password reset link to your email address.
                            Please check your inbox and click the link to reset your password.
                        </Text>
                        <Text c="dimmed" ta="center" size="xs">
                            If you don't see the email, check your spam folder.
                        </Text>
                        <Button
                            variant="subtle"
                            onClick={() => setStatus('idle')}
                            mt="sm"
                        >
                            Send another link
                        </Button>
                    </Stack>
                </Card>
            </Flex>
        )
    }

    return (
        <Flex
            justify="center"
            align="center"
        >
            <Card
                withBorder
                shadow="sm"
                p="md"
                w={400}
            >
                <form onSubmit={formik.handleSubmit}>
                    <Stack gap="sm">

                        <TextInput
                            type="email"
                            label="Email"
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && formik.errors.email}
                        />

                        <Button
                            type="submit"
                            fullWidth
                            loading={formik.isSubmitting}
                            disabled={!formik.isValid || formik.isSubmitting}
                            mt="md"
                        >
                            Request Password Reset Link
                        </Button>

                    </Stack>
                </form>
            </Card>
        </Flex>
    )
}

export default RequestPasswordResetForm
